export interface IParams {
  [key: string]: string;
}

export interface ISome {
  fn(a: string): void;
  key: string;
}

export interface IBindGoogle2fa {
  code: string; // google 码
  secret: string;
  from: number; // 绑定类型从bybit_pc里面查后改掉此处注释
}

export interface ITrustDeviceResult {
  list: Array<{
    device_id: string;
    device_name: string;
    infos: Array<{
      last_login_time: string;
      ip: string;
      last_localtion: string;
    }>;
    platform: string;
  }>;
}

export interface ICountryListItem {
  area_code: number;
  code: string;
  is_current: boolean;
  is_login: boolean;
  is_register: boolean;
  is_trade: boolean;
  name_en: string;
  'name_zh-CN': string;
  'name_zh-MY': string;
}
export interface AccountActivityParams {
  limit: number;
  page: number;
  type?: Entrance; // 1: 查询登录记录  2: 查询安全操作记录
}

export enum ActivityResult {
  SUCCESS = '1',
  FAIL = '2',
}

export enum Entrance {
  LOGIN_RECORD = 1, // 登录记录
  SECURITY_OPERATION_RECORD = 2, // 安全操作记录
}

export interface IChangeWithDrawParams {
  withdraw_addr_level: number;
  google2fa: string;
  email_code: string;
  from: number;
}

export enum WithdrawType {
  ONLY_ADDRESS_WITHDRAW = '1', // 仅地址簿提币
  NEW_ADDRESS_LIMIT = '2', // 仅地址簿提币和新地址提币都开启
  NOT_OPEN_ADDRESS_WITHDRAW = '0', // 仅地址簿提币和新地址提币均为开启
  FETCH_COIN_NO_AUTH = '2', // 提币免验证开启
}

export enum AvatarType {
  DEFAULT = 'default',
  NFT = 'nft',
  ANIMAL_HEAD = 'animalHead',
  COIN = 'coin',
}

export interface IGetSecurityItemsResult {
  canUnbindEmail: boolean;
  canUnbindGa: boolean;
  canUnbindMobile: boolean;
  canUnbind: boolean;
  memberId?: string;
  selfUnbindToken: string;
  vagueEmail: string;
  vagueMobile: string;
  canUnbindPaymentPassword: boolean;
}

export interface ISelfUnbindSecurityRequest {
  securityItem: number | string;
  riskToken: string;
  selfUnbindToken: string;
  riskTokenType: string | number;
  riskVer: string | number;
}

export interface ISelfUnbindSecurityResult {
  nextStep: number | string;
  needUploadDoc: boolean;
  contactEmail: string;
  riskToken: string;
  riskTokenType: string | number;
  riskVer: string;
  selfUnbindToken: string;
}

export interface ISubmitSelfUnbindInfoRequest {
  securityItem: number | string;
  contactEmail?: string;
  newCountryCode?: string | number;
  newMobile: string;
  newEmail: string;
  newSecurityVerifyCode?: string;
  checkVerifyCode: number | string;
  docIds?: string[];
  selfUnbindToken: string;
  [key: string]: any;
}
export interface IEmailOperationType {
  type: string;
}

export interface ISendEmailPrivate {
  from: number;
  email: string;
}

export interface IUnbindEmailParams {
  email_code: string;
  email_from: number;
  mobile_code: string;
  mobile_from: number;
  google2fa: string;
}

export interface IChangeEmailParams {
  new_email: string;
  new_email_code: string;
  new_email_from: string | number;
  old_email_code: string;
  old_email_from: string | number;
  mobile_code?: string;
  mobile_from?: string | number;
  google2fa: string;
}

export interface IChangeMobile {
  new_mobile: string;
  new_mobile_code: string;
  new_mobile_from: string | number;
  old_mobile_code: string;
  old_mobile_from: string | number;
  email_code: string;
  email_from: string | number;
  google2fa: string;
}

export interface IPreSelfUnbindParams {
  securityItem: number;
  newCountryCode: string | number;
  newMobile: string;
  newEmail: string;
  newSecurityVerifyCode: string;
  selfUnbindToken: string;
}

export interface ISubmitSelfUnbindInfoParams {
  securityItem: string;
  contactEmail: string;
  newCountryCode: string | number;
  newMobile: string;
  newEmail: string;
  docIds: any;
  nextStep?: number | string;
  selfUnbindToken: string;
}

export interface ISelfUnbindSecurityItemV2 {
  selfUnbindToken: string;
  securityItem: string | number;
  riskToken: string;
  riskTokenType?: string | number;
  riskVer?: string;
  from?: string | number;
  entrance?: string | number;
  newCountryCode: string;
  newMobile: string;
  newEmail: string;
  nextStep?: number | string;
}

export interface IReportFileUploadParams {
  selfUnbindToken: string;
  resourceId: string;
}
